// extracted by mini-css-extract-plugin
export default {"servicesTitle":"OurServices_servicesTitle__Aza8h"};